<template>
	<div class="home-background">
		<div class="home-title">
			<div class="title-left">
				<img style="width: 37px; height: 19px;" src="@/assets/images/login/participant_icon.png" />
				<span>참여자 목록</span>
			</div>
		</div>
		<div class="search-content">
			<select class="list-select" v-model="searchCategory">
				<option value="">선택</option>
				<option value="참여자번호">참여자번호</option>
				<option value="참여자이름">참여자이름</option>
				<!-- <option value="데이터분류">데이터분류</option>
				<option value="상태">상태</option> -->
			</select>

			<label 
				class="label-date-picker hidden"
				:style="utils.isEmpty(items.informedConsentDt)? 'color: #ccc' : 'color: #090909'"
			>
				{{
					(
						getDateValue()
					) 
				}} 
				<i class="mx-icon">
					<i class="mx-icon-calendar">
							<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024" width="1em" height="1em">
								<path d="M940.218182 107.054545h-209.454546V46.545455h-65.163636v60.50909H363.054545V46.545455H297.890909v60.50909H83.781818c-18.618182 0-32.581818 13.963636-32.581818 32.581819v805.236363c0 18.618182 13.963636 32.581818 32.581818 32.581818h861.090909c18.618182 0 32.581818-13.963636 32.581818-32.581818V139.636364c-4.654545-18.618182-18.618182-32.581818-37.236363-32.581819zM297.890909 172.218182V232.727273h65.163636V172.218182h307.2V232.727273h65.163637V172.218182h176.872727v204.8H116.363636V172.218182h181.527273zM116.363636 912.290909V442.181818h795.927273v470.109091H116.363636z">
								</path>
							</svg>
						</i>
					<i class="mx-icon-clear"
						@click="clearDate()"
					>
						<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024" width="1em" height="1em">
							<path d="M810.005333 274.005333l-237.994667 237.994667 237.994667 237.994667-60.010667 60.010667-237.994667-237.994667-237.994667 237.994667-60.010667-60.010667 237.994667-237.994667-237.994667-237.994667 60.010667-60.010667 237.994667 237.994667 237.994667-237.994667z">
							</path>
						</svg>
					</i>
				</i>
				<date-picker
					ref="date-picker"
					v-model="items.informedConsentDtTemp"
					value-type="format"
					format="YYYY-MM-DD"
					style="width: 0px; height: 0px; overflow: hidden;"
					v-validate="'required'"
					name="informedConsentDt"
					data-vv-as="Consent Date"
					confirm
				/>
			</label>
			<div
				class="search-btn"
				style="position: relative; display: none;"
				:style="addSearchYn ? 'background-color: #0176F9;' : ''"
				@click.stop="openSearch($event);"
			>
				<img style="width: 14.65px; height: 13.84px; pointer-events: none;" src="@/assets/images/home/search_add.png"/>
				상세검색
			</div>
			<!-- 상세 검색 영역 -->
			<div
				class="add-search"
				:style="addSearchYn ? 'opacity: 1; visibility: visible; top:' + yPosistion + '; left:' + xPosistion + ';' : 'top:' + yPosistion + '; left:' + xPosistion + ';'"
			>
				<div class="min-title">상세 필터 검색</div>
				<div class="add-search-content">
					<div class="search-row">
						<div class="search-title-box">
							분만 예정일
						</div>
						<select class="list-select"></select>
					</div>
					<div class="search-row">
						<div class="search-title-box">
							분만 여부
						</div>
						<select class="list-select"></select>
					</div>
					<div class="search-row">
						<div class="search-title-box">
							응급 지원
						</div>
						<select class="list-select"></select>
					</div>
					<div class="search-row">
						<div class="search-title-box">
							최종 업데이트
						</div>
						<select class="list-select"></select>
					</div>
					<div class="search-row">
						<div class="search-title-box">
							미전송 내역
						</div>
						<select class="list-select"></select>
					</div>
				</div>
				<div class="btn-bottom">
					<button type="button" class="btn-save fright" title="Save" @click.stop="searchSave();">
						완료
					</button>
					<button type="button" class="btn-cancel fright" title="Cancel" @click.stop="searchClose();">
						취소
					</button>
				</div>
			</div>
			<input
				type="text"
				class="input-crud"
				style="width: 240px;"
				v-model="searchText"
				@keyup="keyupHandler"
			/>
			<div class="search-btn" @click.stop="selectParticipantList()">
				<img src="@/assets/images/home/search.png"/>
				검색
			</div>
			<div class="btn-right">
				<div class="add-btn" @click="doOpenCreate()">
					참여자 등록
				</div>
				<!-- <div class="excel-btn">
					엑셀 업로드
				</div> -->
			</div>
		</div>
		<div class="home-bottom" style="height: calc(100% - 165px);">
			<div class="content-box">
				<table class="tb-list-vertical" style="table-layout: fixed;">
					<colgroup>
						<!-- <col width="12%">
						<col width="16%">
						<col width="16%">
						<col width="20%">
						<col width="18%">
						<col width="18%"> -->
					</colgroup>
					<thead>
						<th>참여자 번호</th>
						<th>이름</th>
						<th>전화번호</th>
						<th>임신 주수</th>
						<th>분만 예정일</th>
						<th>응급 지원</th>
						<th>최종 전송 일자</th>
						<th>미전송 내역</th>
					</thead>
					<tbody>
						<template
							v-for="(patients, index) in participantList"
						>
							<tr 
								:key="index"
								@click="doOpenData(patients)"
							>
								<td>{{patients.id != '' ? patients.id : '-'}}</td>
								<td>{{patients.name != '' ? patients.name : '-'}}</td>
								<td>{{patients.phone != '' ? patients.phone : '-'}}</td>
								<td>{{setTodayWeeks(patients)}}</td>
								<td>{{patients.childBirth != '' ? patients.childBirth.substring(0,11) : '-'}}</td>
								<td>{{patients.supportCnt+'회'}}</td>
								<td>{{patients.updateDate != '' ? patients.updateDate.substring(0,11) : '-'}}</td>
								<td>-</td>
							</tr>
						</template>
						<tr v-if="participantList.length == 0">
							<td colspan="8" class="no-list">
								데이터가 존재하지 않습니다.
							</td>
						</tr>
					</tbody>
				</table>
				<div class="pagination-wrap">
					<pagination
						:data="pagination"
						:show-disabled="true"
						:limit="4"
						@pagination-change-page="doSearchPage"
					>
						<button type="button" slot="prev-nav" class="page-prev">&lt;</button>
						<button type="button" slot="next-nav" class="page-next">&gt;</button>
					</pagination>
				</div>
			</div>
		</div>
		<ParticipantDetail v-if="isDataPopup" :collectData="collectData"/>
		<ParticipantCreate v-if="isCreatePopup" />
	</div>
</template>

<script>
import Vue from "vue";
import VeeValidator from "vee-validate";
import EventBus from "@/script/EventBus.js";
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import ParticipantDetail from "@/components/participant/ParticipantDetail.vue";
import ParticipantCreate from "@/components/participant/ParticipantCreate.vue";
import axios from "axios";
Vue.use(VeeValidator);

export default {
	name: "ParticipantList",
	created() {
		this.logger.debug(this, ".created()");
		console.log(this.userInfo.userId);
		this.selectParticipantList();
	},
	mounted() {
		this.logger.debug(this, ".mounted()");
		this.nowDate();
		this.$nextTick(function () {
			if(this.$parent.current_page != "" && this.$parent.current_page != undefined){
				this.doSearchPage(this.$parent.current_page);
			}
		});
	},
	data() {
		return {
			items: {},
			isMode: 1,
			today: "",
			isDataPopup: false,
			isCreatePopup: false,
			addSearchYn: false,
			xPosistion: "",
			yPosistion: "",
			participantList: [],
			pagination: {},
			searchText: "",
			searchCategory: "",
			collectData: {},
		};
	},
	components: {
		DatePicker,
		ParticipantDetail,
		ParticipantCreate,
	},
	watch: {
		searchText: function(val) {
			// this.item.pageName = val;
			this.items.searchText = val;
			this.items.pageNum = 1;
		},
		searchCategory: function(val) {
			// this.item.pageName = val;
			this.items.searchCategory = val;
			this.items.pageNum = 1;
		}
	},
	methods: {
		selectMode(code){
			if(code == 1){ this.isMode = 1;}
			else{this.isMode = 2;}
		},
		keyupHandler(event) {
			this.logger.debug(this, "keyupHandler(event)");
			// this.searchTextVal = event.target.value;
			if (event.keyCode == 13)
			{
				EventBus.$emit("project-loading", true);
				this.selectParticipantList();
			}
		},
		selectParticipantList(){
			EventBus.$emit("project-loading", true);
			this.logger.debug(this, "selectParticipantList()");
			this.openProjectIndex = -1;
			axios
				.post(this.config.contextRoot + "/participant/selectParticipantList.do", this.items)
				.then((response) => {
					console.log(response);
					this.participantList = response.data.participantList;
					this.pagination = response.data.pagination;

					EventBus.$emit("project-loading", false);
				})
				.catch((error) => {
					this.exceptionHandler(this, error);
				});
		},
		doSearchPage(page) {
			this.logger.debug(this, "doSearchPage()");
			if (typeof page === "undefined" || page === 0) {
				page = 1;
			}
			this.items.pageNum = page;
			this.selectParticipantList();
		},
		nowDate(){
			const date = new Date();
			const year = date.getFullYear(); // YYYY
			const month = date.getMonth() + 1; // MM
			const day = date.getDate();	// DD
			const hours = date.getHours(); // HH
			const minutes = date.getMinutes(); // MM
			const seconds = date.getSeconds(); // ss
			const week = ['일', '월', '화', '수', '목', '금', '토'];
			setTimeout(function() {
                this.nowDate()
            }.bind(this), 1000);

			this.today = year + '-' + month.toString().padStart(2, '0') + '-' + day.toString().padStart(2, '0') + ' (' + week[date.getDay()] + ') ' + hours.toString().padStart(2, '0') + ':' + minutes.toString().padStart(2, '0') + ':' + seconds.toString().padStart(2, '0');
		},
		getDateValue() {
			var informedConsentDtTemp = this.items.informedConsentDtTemp;
			var informedConsentDt = this.items.informedConsentDt;

			if(this.utils.isEmpty(informedConsentDtTemp))
			{
				if(this.utils.isEmpty(informedConsentDt))
				{
					return "YYYY-MM-DD"
				}
				else
				{
					return informedConsentDt;
				}
			}
			else
			{
				{
					this.$set(this.items, "informedConsentDt", informedConsentDtTemp);
				}
				return this.items.informedConsentDt;
			}
		},
		clearDate() {
			this.$set(this.items, "informedConsentDt", "");
			this.$set(this.items, "informedConsentDtTemp", "");
			setTimeout(function() {
				let popup = document.getElementsByClassName("mx-datepicker-popup")[0];
				popup.style.display = "none";
			}.bind(this), 0);
		},
		doOpenData(patients) {
			this.logger.debug(this, "doOpenData()");
			this.collectData = patients;
			this.isDataPopup = true;
		},
		doOpenCreate() {
			this.logger.debug(this, "doOpenCreate()");
			this.isCreatePopup = true;
		},
		openSearch(event){
			this.xPosistion = (event.clientX - event.offsetX) + "px";
			this.yPosistion = (event.clientY - event.offsetY - 32) + "px";
			if(this.addSearchYn === true){
				this.addSearchYn = false;
			}
			else{
				this.addSearchYn = true;
			}
		},
		searchSave(){
			if(this.addSearchYn === true){
				this.addSearchYn = false;
			}
			else{
				this.addSearchYn = true;
			}
		},
		searchClose(){
			if(this.addSearchYn === true){
				this.addSearchYn = false;
			}
			else{
				this.addSearchYn = true;
			}
		},
		setTodayWeeks(patients){
			var result = "";
			const rDate = new Date(patients.createDate.substring(0, 10));
			const date = new Date();
			const diff = date.getTime() - rDate.getTime();
			const resultDay = Math.abs(diff / (1000 * 60 * 60 * 24));
			result = parseInt(((resultDay)/7)) + parseInt(patients.weeks);
			if(isNaN(result)){
				result = 0;
			}
			return result + "주차";
		}
	},
};
</script>
<style>
@import '../../assets/css/login/login.css';
.home-background{
	width: 100%;
	height: 100%;
}
.home-title{
	width: 100%;
	height: 29px;
	display: flex;
    justify-content: space-between;
}
.title-left{
	display: flex;
    align-items: center;
    column-gap: 12px;
	font-size: 24px;
	font-weight: bold;
}
.title-right{
	display: flex;
    align-items: center;
	font-size: 14px;
	column-gap: 20px;
}
.warn-dot{
	width: 16px;
	height: 16px;
	border-radius: 50px;
}
.font-red{
	color: #F94848;
}
.red{
	background-color: #F94848;
}
.yellow{
	background-color: #FFAD09;
}
.warn-wrap{
	display: flex;
	align-items: center;
    column-gap: 4px;
}
.home-top{
	width: 100%;
	height: 180px;
	display: flex;
	column-gap: 20px;
	margin: 20px 0;
}
.home-bottom{
	width: 100%;
	height: calc(100% - 269px);
	display: flex;
	column-gap: 20px;
	margin: 20px 0;
}
.content-box{
	width: 100%;
	border-radius: 8px;
	overflow: hidden;
	box-shadow: 0 0 10px 0px #ccc;
	background-color: #fff;
	position: relative;
}
.top-sub-title-red{
	width: 100%;
	height: 52px;
	background-color: #F94848;
	display: flex;
    align-items: center;
	justify-content: space-between;
    padding-left: 32px;
    color: #FFF;
	font-size: 20px;
}
.top-sub-title-green{
	width: 100%;
	height: 52px;
	background-color: #4BD985;
	display: flex;
    align-items: center;
	justify-content: space-between;
    padding-left: 32px;
    color: #FFF;
	font-size: 20px;
}
.count-dot{
	width: 8px;
	height: 8px;
	border: 1px solid #fff;
	border-radius: 50px;
}
.top-count{
	display: flex;
    column-gap: 5px;
	margin-right: 32px;
}
.white{
	background-color: #fff;
}
.none-content{
	width: 100%;
    height: calc(100% - 52px);
    display: flex;
    justify-content: center;
    align-items: center;
	font-size: 18px;
	color: #A9A9A9;
}
.left-btn{
	width: 31px;
	height: 38px;
	background-image: url(../../assets/images/home/left_btn.png);
	background-repeat: no-repeat;
	background-position: center;
	background-size: 31px 38px;
}
.right-btn{
	width: 31px;
	height: 38px;
	background-image: url(../../assets/images/home/right_btn.png);
	background-repeat: no-repeat;
	background-position: center;
	background-size: 31px 38px;
}
.name-tag{
	width: 44px;
	height: 22px;
	background-color: #EFEFEF;
	border-radius: 11px;
	font-size: 14px;
	color: #A9A9A9;
	display: flex;
    justify-content: center;
    align-items: center;
}
.data-zone{
	display: flex;
    justify-content: flex-start;
	align-items: center;
	column-gap: 10px;
	font-size: 16px;
	font-weight: bold;
}
.dot-line{
	height: 64px;
	border: 1px solid #DDDDDD;
	border-style: dashed;
}
.top-data{
	display: flex;
    flex-direction: column;
    align-items: flex-start;
    row-gap: 4px;
}
.table-name{
	font-size: 20px;
	font-weight: bold;
	width: 100%;
	height: 60px;
	display: flex;
    align-items: center;
    justify-content: flex-start;
    column-gap: 10px;
    padding-left: 32px;
}
.table-btn{
	width: 66px;
	height: 29px;
	border-radius: 15px;
	font-size: 16px;
	font-weight: 600;
	color: #6D6D6D;
}
.table-btn:hover{
	color: #FFF;
	background-color: #555555;
}
.btn-on{
	color: #FFF;
	background-color: #555555;
}
.list-select{
	width: 240px;
	height: 40px;
    padding: 0 15px;
    border: 1px solid #A9A9A9;
	border-radius: 5px;
    font-size: 10pt;
    color: #090909;
	
}
.search-content{
	display: flex;
    align-items: center;
	column-gap: 10px;
	margin: 25px 0;
	padding-bottom: 25px;
    border-bottom: 1px solid #BDC1C6;
}
.search-btn{
	min-width: 100px;
	height: 40px;
	border-radius: 5px;
	background-color: #555555;
	color: #fff;
	display: flex;
    justify-content: center;
    align-items: center;
	column-gap: 8px;
	cursor: pointer;
	font-size: 16px;
}
.search-btn:hover{
	background-color: #0176F9;
}
.search-btn > img{
	width: 13.5px;
	height: 14.5px;
}
.status{
	min-width: 55px;
	width: 55px;
	height: 22px;
	border-radius: 12px;
	color: #fff;
	font-size: 14px;
	display: flex;
	justify-content: center;
    align-items: center;
}
.add-search{
	visibility: hidden;
	opacity: 0;
	width: 430px;
	height: fit-content;
	position: absolute;
	background-color: #fff;
	box-shadow: 0 0 10px 0px #ccc;
	border-radius: 8px;
	color: #2A2A2A;
	transition: all 0.2s ease;
}
.min-title{
	font-size: 18px;
	font-weight: bold;
	padding: 14px 20px;
	border-bottom: 1px solid #DDDDDD;
}
.search-title-box{
	width: 140px;
	height: 40px;
	border-radius: 5px;
	background-color: #EEEEEE;
	display: flex;
    justify-content: center;
    align-items: center;
	font-size: 16px;
	font-weight: bold;
}
.search-row{
	display: flex;
    align-items: center;
    justify-content: center;
    column-gap: 10px;
}
.add-search-content{
	padding: 17px 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    row-gap: 8px;
}
.btn-bottom{
	height: 40px;
	display: flex;
    align-items: center;
    justify-content: center;
    column-gap: 8px;
	margin-bottom: 28px;
}
.btn-bottom > button{
	height: 40px;
	width: 100px;
	max-width: 100px;
	min-width: 100px;
}
.hidden{
	display: none;
}
.add-btn{
	float: right;
	min-width: 113px;
	height: 40px;
	border: 1px solid #0176F9;
	border-radius: 5px;
	background-color: #fff;
	color: #0176F9;
	display: flex;
    justify-content: center;
    align-items: center;
	column-gap: 8px;
	cursor: pointer;
	font-size: 16px;
}
.add-btn:hover{
	background-color: #0176F9;
	color:#fff;
}
.excel-btn{
	float: right;
	min-width: 113px;
	height: 40px;
	border: 1px solid #555F6D;
	border-radius: 5px;
	background-color: #fff;
	color: #555F6D;
	display: flex;
    justify-content: center;
    align-items: center;
	column-gap: 8px;
	cursor: pointer;
	font-size: 16px;
}
.excel-btn:hover{
	background-color: #555F6D;
	color:#fff;
}
.btn-right{
	margin-left: auto;
    display: flex;
    flex-direction: row;
    column-gap: 10px;
}
</style>

